/* eslint-disable no-unused-vars */
/**
 * @description Class containing the initial configuration style input
 * @author ConfigInitTable?
 * @version 1.0.0
 */
'use strict';
// Modules
import * as CSS from 'csstype'

// Others
import { InitConfigColor } from '../../utils/colors'
const Colors = InitConfigColor.getColors()
import { numberFormat } from '../../utils'
import { CSSObject } from 'styled-components'
import { useCallback } from 'react'

// Declare type
export declare type TDefaultInputStyle = {
    container?: {
        styles?: CSSObject
        mediaTable?: boolean
        mediaPhone?: boolean
        stylesTable?: CSSObject
        stylesPhone?: CSSObject
        width?: CSS.Property.Width
        margin?: CSS.Property.Margin
        display?: CSS.Property.Display
        widthPhone?: CSS.Property.Width
        widthTable?: CSS.Property.Width
        minWidth?: CSS.Property.MinWidth
        maxWidth?: CSS.Property.MaxWidth
        position?: CSS.Property.Position
        maxWidthTable?: CSS.Property.MaxWidth
        maxWidthPhone?: CSS.Property.MaxWidth
        flexDirection?: CSS.Property.FlexDirection
        hoverDisplayTooltip?: CSS.Property.Display
    }
    label?: {
        styles?: CSSObject
        activeTitle?: boolean
        color?: CSS.Property.Color
        margin?: CSS.Property.Margin
        border?: CSS.Property.Border
        padding?: CSS.Property.Padding
        colorError?: CSS.Property.Color
        fontSize?: CSS.Property.FontSize
        overflow?: CSS.Property.Overflow
        colorDisabled?: CSS.Property.Color
        colorNotValue?: CSS.Property.Color
        textAlign?: CSS.Property.TextAlign
        fontFamily?: CSS.Property.FontFamily
        whiteSpace?: CSS.Property.WhiteSpace
        textOverflow?: CSS.Property.TextOverflow
        hoverDisplayTooltip?: CSS.Property.Display
    }
    input?: {
        styles?: CSSObject
        activeTitle?: boolean
        width?: CSS.Property.Width
        color?: CSS.Property.Color
        border?: CSS.Property.Border
        padding?: CSS.Property.Padding
        outline?: CSS.Property.Outline
        fontSize?: CSS.Property.FontSize
        borderFocus?: CSS.Property.Border
        borderError?: CSS.Property.Border
        minHeight?: CSS.Property.MinHeight
        textAlign?: CSS.Property.TextAlign
        colorDisabled?: CSS.Property.Color
        borderSuccess?: CSS.Property.Border
        fontFamily?: CSS.Property.FontFamily
        cursorDisabled?: CSS.Property.Cursor
        transform?: CSS.Property.TextTransform
        colorDisabledClick?: CSS.Property.Color
        borderRadius?: CSS.Property.BorderRadius
        cursorDisabledClick?: CSS.Property.Cursor
        hoverDisplayTooltip?: CSS.Property.Display
        fontFamilyDisabled?: CSS.Property.FontFamily
        backgroundColor?: CSS.Property.BackgroundColor
        fontFamilyDisabledClick?: CSS.Property.FontFamily
        backgroundColorDisabled?: CSS.Property.BackgroundColor
        backgroundColorDisabledClick?: CSS.Property.BackgroundColor
    }
    tooltip?: {
        styles?: CSSObject
        top?: CSS.Property.Top
        left?: CSS.Property.Left
        color?: CSS.Property.Color
        zIndex?: CSS.Property.ZIndex
        border?: CSS.Property.Border
        bottom?: CSS.Property.Bottom
        padding?: CSS.Property.Padding
        display?: CSS.Property.Display
        fontSize?: CSS.Property.FontSize
        position?: CSS.Property.Position
        topAfterBefore?: CSS.Property.Top
        boxShadow?: CSS.Property.BoxShadow
        leftAfterBefore?: CSS.Property.Left
        fontFamily?: CSS.Property.FontFamily
        borderAfterBefore?: CSS.Property.Border
        bottomAfterBefore?: CSS.Property.Bottom
        borderRadius?: CSS.Property.BorderRadius
        contentAfterBefore?: CSS.Property.Content
        positionAfterBefore?: CSS.Property.Position
        backgroundColor?: CSS.Property.BackgroundColor
        pointerEventsAfterBefore?: CSS.Property.PointerEvents
    }
    symbol?: {
        styles?: CSSObject
        left?: CSS.Property.Left
        color?: CSS.Property.Color
        bottom?: CSS.Property.Bottom
        position?: CSS.Property.Position
        fontSize?: CSS.Property.FontSize
        colorDisabled?: CSS.Property.Color
        fontFamily?: CSS.Property.FontFamily
        colorDisabledClick?: CSS.Property.Color
        fontFamilyDisabled?: CSS.Property.FontFamily
        fontFamilyDisabledClick?: CSS.Property.FontFamily
    }
    messageError?: {
        pass?: string
        email?: string
        letter?: string
        numeric?: string
        required?: string
        date?: (value: string) => string
        hour?: (value: string) => string
        minimum?: (value: number) => string
        maximum?: (value: number) => string
        range?: (min: number, max: number) => string
    }
    loading?: {
        container?: Node
        size?: string | number
        top?: CSS.Property.Top
        left?: CSS.Property.Left
        right?: CSS.Property.Right
        color?: CSS.Property.Color
        bottom?: CSS.Property.Bottom
        position?: CSS.Property.Position
    }
    tooltipInput?: {
        styles?: CSSObject
        color?: CSS.Property.Color
        zIndex?: CSS.Property.ZIndex
        opacity?: CSS.Property.Opacity
        padding?: CSS.Property.Padding
        fontSize?: CSS.Property.FontSize
        maxWidth?: CSS.Property.MaxWidth
        position?: CSS.Property.Position
        overflow?: CSS.Property.Overflow
        maxHeight?: CSS.Property.MaxHeight
        whiteSpace?: CSS.Property.WhiteSpace
        visibility?: CSS.Property.Visibility
        fontFamily?: CSS.Property.FontFamily
        borderRadius?: CSS.Property.BorderRadius
        textOverflow?: CSS.Property.TextOverflow
        backgroundColor?: CSS.Property.BackgroundColor
    }
    tooltipLabel?: {
        styles?: CSSObject
        color?: CSS.Property.Color
        zIndex?: CSS.Property.ZIndex
        opacity?: CSS.Property.Opacity
        padding?: CSS.Property.Padding
        fontSize?: CSS.Property.FontSize
        maxWidth?: CSS.Property.MaxWidth
        position?: CSS.Property.Position
        overflow?: CSS.Property.Overflow
        maxHeight?: CSS.Property.MaxHeight
        fontFamily?: CSS.Property.FontFamily
        whiteSpace?: CSS.Property.WhiteSpace
        visibility?: CSS.Property.Visibility
        borderRadius?: CSS.Property.BorderRadius
        textOverflow?: CSS.Property.TextOverflow
        backgroundColor?: CSS.Property.BackgroundColor
    }
    boxInput?: {
        styles?: CSSObject
    }
}

export let defaultStyleInput: TDefaultInputStyle = {
    container: {
        width: '100%',
        display: 'flex',
        widthPhone: '100%',
        widthTable: '100%',
        position: 'relative',
        maxWidthTable: '768px',
        maxWidthPhone: '375px',
        flexDirection: 'column',
        hoverDisplayTooltip: 'block'
    },
    label: {
        border: 'none',
        margin: '1px 0',
        fontSize: '13px',
        activeTitle: true,
        textAlign: 'start',
        overflow: 'hidden',
        padding: '5.2px 0px',
        whiteSpace: 'nowrap',
        fontFamily: 'sans-serif',
        textOverflow: 'ellipsis',
        color: Colors.input?.label,
        hoverDisplayTooltip: 'block',
        colorError: Colors.input?.labelError,
        colorNotValue: Colors.input?.labelLight,
        colorDisabled: Colors.input?.labelHight,
    },
    input: {
        outline: '0',
        width: '100%',
        padding: '0 7px',
        fontSize: '13px',
        minHeight: '36px',
        activeTitle: true,
        borderRadius: '5px',
        fontFamily: 'sans-serif',
        cursorDisabled: 'no-drop',
        color: Colors.input?.input,
        hoverDisplayTooltip: 'block',
        cursorDisabledClick: 'pointer',
        fontFamilyDisabled: 'sans-serif',
        fontFamilyDisabledClick: 'sans-serif',
        colorDisabled: Colors.input?.inputHight,
        colorDisabledClick: Colors.input?.primary,
        border: `1px solid ${Colors.input?.inputBorder}`,
        borderFocus: `1px solid ${Colors.input?.primary}`,
        backgroundColor: Colors.input?.inputBackgroundColor,
        borderError: `1px solid ${Colors.input?.inputBorderError}`,
        borderSuccess: `1px solid ${Colors.input?.inputBorderSuccess}`,
        backgroundColorDisabled: Colors.input?.inputBackgroundColorDisabled,
        backgroundColorDisabledClick: Colors.input?.inputBackgroundColorDisabledClick,
    },
    tooltip: {
        left: '0px',
        zIndex: 10,
        bottom: '-35%',
        display: 'none',
        fontSize: '11px',
        borderRadius: '2px',
        padding: '2px 10px',
        position: 'absolute',
        topAfterBefore: '100%',
        leftAfterBefore: '85%',
        fontFamily: 'sans-serif',
        positionAfterBefore: 'absolute',
        pointerEventsAfterBefore: 'none',
        color: Colors.input?.tooltipColor,
        borderAfterBefore: 'solid transparent',
        border: `1px solid ${Colors.input?.tooltipBorder}`,
        backgroundColor: Colors.input?.tooltipBackgroundColor,
        boxShadow: `0px 0px 3px 1px ${Colors.input?.tooltipColorBoxShadow}`,
    },
    symbol: {
        left: '10px',
        bottom: '10px',
        fontSize: '13px',
        position: 'absolute',
        fontFamily: 'sans-serif',
        color: Colors.input?.symbol,
        fontFamilyDisabled: 'sans-serif',
        fontFamilyDisabledClick: 'sans-serif',
        colorDisabled: Colors.input?.symbolHight,
        colorDisabledClick: Colors.input?.primary,
    },
    messageError: {
        required: 'Campo requerido.',
        numeric: 'Solo puede contener números',
        email: 'El formato de email no es válido',
        letter: 'El campo debe contener solo letra0s.',
        minimum: (value: number) => `El valor es mínimo: ${numberFormat(Number(value))}.`,
        maximum: (value: number) => `El valor es máximo: ${numberFormat(Number(value))}.`,
        date: (value: string) => `La fecha no es valida: ${numberFormat(Number(value))}.`,
        hour: (value: string) => `La hora no es validad: ${numberFormat(Number(value))}.`,
        range: (min: number, max: number) => `El rango de caracteres es de ${min} a ${max}.`,
        pass: 'La contraseña debe tener al entre 8 y 16 caracteres, al menos un dígito, al menos una minúscula y al menos una mayúscula. Puede tener otros símbolos.',
    },
    loading: {
        color: Colors.loading?.color
    },
    tooltipInput: {
        zIndex: 1,
        opacity: '0',
        padding: '5px',
        color: '#fff',
        maxWidth: '150px',
        fontSize: '10px',
        position: 'fixed',
        maxHeight: '80px',
        borderRadius: '4px',
        visibility: 'hidden',
        fontFamily: 'sans-serif',
        backgroundColor: '#00000099',
    },
    tooltipLabel: {
        zIndex: 1,
        opacity: '0',
        padding: '5px',
        color: '#fff',
        maxWidth: '150px',
        fontSize: '10px',
        position: 'fixed',
        maxHeight: '80px',
        borderRadius: '4px',
        visibility: 'hidden',
        fontFamily: 'sans-serif',
        backgroundColor: '#00000099',
    }
}

// Config init input
export const useInitConfigInput = (): [TDefaultInputStyle, (newStyles: TDefaultInputStyle) => void] => {

    const configInputStyles = useCallback((newStyles: TDefaultInputStyle) => {
        defaultStyleInput = {
            container: {
                ...defaultStyleInput.container,
                ...(newStyles?.container || {})
            },
            label: {
                ...defaultStyleInput.label,
                ...(newStyles?.label || {})
            },
            tooltip: {
                ...defaultStyleInput.tooltip,
                ...(newStyles?.tooltip || {})
            },
            input: {
                ...defaultStyleInput.input,
                ...(newStyles?.input || {})
            },
            symbol: {
                ...defaultStyleInput.symbol,
                ...(newStyles?.symbol || {})
            },
            messageError: {
                ...defaultStyleInput.messageError,
                ...(newStyles?.messageError || {})
            },
            loading: {
                ...defaultStyleInput.loading,
                ...(newStyles?.loading || {})
            },
            tooltipInput: {
                ...defaultStyleInput.tooltipInput,
                ...(newStyles?.tooltipInput || {})
            },
            tooltipLabel: {
                ...defaultStyleInput.tooltipLabel,
                ...(newStyles?.tooltipLabel || {})
            },
            boxInput: {
                ...defaultStyleInput.boxInput,
                ...(newStyles?.boxInput || {})
            }
        }
    }, [])

    return [defaultStyleInput, configInputStyles]
}